module.exports = __webpack_public_path__ + "static/media/movie1.6355ea0e.m4v";